import { MAX_QUESTION_LENGTH } from './constants'
import { SlideQuestionErrorKeys } from './keys'
import { type ValidationError, type Validator } from './types'

// Maximum allowed value for min/max list length
const MAX_LIST_LENGTH_LIMIT = 100

export const validateSortableStringList: Validator = async (_, question) => {
  const errors: ValidationError[] = []
  const trimmedQuestion = question.question?.trim()

  // Validate question
  if (!trimmedQuestion) {
    errors.push({
      field: 'question',
      key: SlideQuestionErrorKeys.question_sortable_string_list_missing,
    })
  } else if (trimmedQuestion.length > MAX_QUESTION_LENGTH) {
    errors.push({
      field: 'question',
      key: SlideQuestionErrorKeys.question_sortable_string_list_too_long,
    })
  }

  // Validate minListLength
  if (question.minListLength === undefined || question.minListLength === null) {
    errors.push({
      field: 'minListLength',
      key: SlideQuestionErrorKeys.question_sortable_string_list_min_length_missing,
    })
  } else if (question.minListLength <= 0) {
    errors.push({
      field: 'minListLength',
      key: SlideQuestionErrorKeys.question_sortable_string_list_min_length_invalid,
    })
  } else if (!Number.isInteger(question.minListLength)) {
    errors.push({
      field: 'minListLength',
      key: SlideQuestionErrorKeys.question_sortable_string_list_min_length_not_integer,
    })
  } else if (question.minListLength > MAX_LIST_LENGTH_LIMIT) {
    errors.push({
      field: 'minListLength',
      key: SlideQuestionErrorKeys.question_sortable_string_list_min_length_exceeds_max_allowed,
    })
  }

  // Validate maxListLength
  if (question.maxListLength === undefined || question.maxListLength === null) {
    errors.push({
      field: 'maxListLength',
      key: SlideQuestionErrorKeys.question_sortable_string_list_max_length_missing,
    })
  } else if (question.maxListLength <= 0) {
    errors.push({
      field: 'maxListLength',
      key: SlideQuestionErrorKeys.question_sortable_string_list_max_length_invalid,
    })
  } else if (!Number.isInteger(question.maxListLength)) {
    errors.push({
      field: 'maxListLength',
      key: SlideQuestionErrorKeys.question_sortable_string_list_max_length_not_integer,
    })
  } else if (question.maxListLength > MAX_LIST_LENGTH_LIMIT) {
    errors.push({
      field: 'maxListLength',
      key: SlideQuestionErrorKeys.question_sortable_string_list_max_length_exceeds_max_allowed,
    })
  }

  // Validate min <= max (only if both are valid positive integers within limits)
  const minLength = question.minListLength
  const maxLength = question.maxListLength

  const minIsValid =
    minLength !== undefined &&
    minLength !== null &&
    minLength > 0 &&
    Number.isInteger(minLength) &&
    minLength <= MAX_LIST_LENGTH_LIMIT

  const maxIsValid =
    maxLength !== undefined &&
    maxLength !== null &&
    maxLength > 0 &&
    Number.isInteger(maxLength) &&
    maxLength <= MAX_LIST_LENGTH_LIMIT

  if (minIsValid && maxIsValid && minLength > maxLength) {
    errors.push({
      field: 'minListLength',
      key: SlideQuestionErrorKeys.question_sortable_string_list_min_greater_than_max,
    })
  }

  return errors
}
